export const MERCHANT_PROFILE_REQUESTING =
	'merchantProfile/MERCHANT_PROFILE_REQUESTING';
export const MERCHANT_PROFILE_SUCCESS =
	'merchantProfile/MERCHANT_PROFILE_SUCCESS';
export const MERCHANT_PROFILE_ERROR = 'merchantProfile/MERCHANT_PROFILE_ERROR';

export const MERCHANT_LIST_REQUESTING =
	'merchantProfile/MERCHANT_LIST_REQUESTING';
export const MERCHANT_LIST_SUCCESS = 'merchantProfile/MERCHANT_LIST_SUCCESS';
export const MERCHANT_LIST_ERROR = 'merchantProfile/MERCHANT_LIST_ERROR';

export const UPDATE_USER_PROFILE_REQUESTING =
	'merchantProfile/UPDATE_USER_PROFILE_REQUESTING';
export const UPDATE_USER_PROFILE_SUCCESS =
	'merchantProfile/UPDATE_USER_PROFILE_SUCCESS';
export const UPDATE_USER_PROFILE_ERROR =
	'merchantProfile/UPDATE_USER_PROFILE_ERROR';

export const UPDATE_MERCHANT_ADDRESS =
	'merchantProfile/UPDATE_MERCHANT_ADDRESS';
export const UPDATE_MERCHANT_ADDRESS_SUCCESS =
	'merchantProfile/UPDATE_MERCHANT_ADDRESS_SUCCESS';
export const UPDATE_MERCHANT_ADDRESS_ERROR =
	'merchantProfile/UPDATE_MERCHANT_ADDRESS_ERROR';

export const SAVE_MERCHANT_INFO = 'merchantProfile/SAVE_MERCHANT_INFO';

export const SAVE_MERCHANT_ONBOARDING_INFO =
	'merchantProfile/SAVE_MERCHANT_ONBOARDING_INFO';
export const SET_MERCHANT_FEATURE_CONFIG =
	'merchantProfile/SET_MERCHANT_FEATURE_CONFIG';
export const UPDATE_PAYLINK_FEATURE_CONFIG =
	'merchantProfile/UPDATE_PAYLINK_FEATURE_CONFIG';
export const REQUESTING_FEATURE_CONFIG =
	'merchantProfile/REQUESTING_FEATURE_CONFIG';
